import { useEffect } from 'react'

// AK-252: the real page lives on the info site, linked from the footer.
const Terms = () => {
  useEffect(() => {
    window.location.replace('https://www.info.akedo.gg/terms-of-service')
  }, [])
  return null
}

export default Terms
